// General
export const API_ENDPOINT: string = process.env.NEXT_PUBLIC_API_ENDPOINT as string

// Firebase Client
export const FB_API_KEY: string = process.env.NEXT_PUBLIC_FB_API_KEY as string
export const FB_AUTH_DOMAIN: string = process.env.NEXT_PUBLIC_FB_AUTH_DOMAIN as string
export const FB_PROJECT_ID: string = process.env.NEXT_PUBLIC_FB_PROJECT_ID as string
export const FB_STORAGE_BUCKET: string = process.env.NEXT_PUBLIC_FB_STORAGE_BUCKET as string
export const FB_MESSAGING_SENDER_ID: string = process.env.NEXT_PUBLIC_FB_MESSAGING_SENDER_ID as string
export const FB_APP_ID: string = process.env.NEXT_PUBLIC_FB_APP_ID as string
